import { customAlphabet } from 'nanoid';

export const getUniqueId = customAlphabet('1234567890abcdef', 20);
